export enum NotesTypeFieldsName {
    NAME = 'NAME',
    TITLE = 'TITLE',
    NOTES_COMPONENTS = 'NOTESCOMPONENTS',
    INFORMATION = 'INFORMATION',
}
